import {CHORD_TYPE} from './ChordEffects.js';
import {IntegerParameter} from "parameters/AbstractParameter.js";

export default superclass => class extends superclass  {
    initializeChordParameters() {
        this.progressionStartParameter = new IntegerParameter(
            'progressionStart',
            this, () => 0,
            {
                defaultValue: 1,
                min: 1,
                max: 7
            });
        this.registerParameter(this.progressionStartParameter);
    }

    getChord(chord) {
        return this.effects.find(x => x.numeral === chord);
    }

    getStartingChord() {
        return this.progressionStartParameter.get();
    }
    
    getPossibleNextEffects(chord) {
        let effect = this.getChord(chord);
        let edges = this.adjacencyLists[effect.id] || [];
        return edges.map(
            e => e.effect)
            .filter(e => e.getChordEffectType() === CHORD_TYPE);
    }

    getPossibleNextChords(chord) {
        return this.getPossibleNextEffects(chord).map(x => x.numeral);
    }

    getNextChordEffect(chord, position=0) {
        let possibilities = this.getPossibleNextEffects(chord);
        let effect = this.getChord(chord);
        if (effect.nextChords[position] !== undefined) {
            return effect.nextChords[position];
        } else {
            // if not chosen, choose the 1st connected chord.
            // if none is connected, then choose the I chord
            return possibilities[0] ||
                this.getChord(1);
        }
    }

    getNextChord(chord, position=0) {
        return this.getNextChordEffect(chord, position).numeral;
    }
}
